export const fr = {
  title: `La trousse`,
  whatToConsult: `Quelle section voulez-vous consulter?`,
  aboutEpilepsy: `En savoir plus sur l'épilepsie`,
  beWitness: `Que faire si je suis témoin d'une crise?`,
  impacts: `Les impacts de l’épilepsie`,
  mythsAndFacts: `Questions fréquentes`,
  tools: `Outils divers`,
  treatments: `Les traitements de l’épilepsie`
};
